/* @flow */

import { createSelector } from 'reselect';
import type { ErrorType } from '../actions/errors';

const errors = (state: any): ErrorType[] => state.errors;

export const getErrors = createSelector(
  [errors],
  e => e,
);

export const hasError = createSelector(
  [getErrors],
  e => e.length > 0,
);



// WEBPACK FOOTER //
// ./src/selectors/errors.js